import { ImportFileType, IUnmanagedBusiness } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { IUnmanagedBusinessRepository } from '@/coreInfrastructureModule/interfaces/IUnmanagedBusinessRepository';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { file } from 'jszip';

/**
 * 未管理の取引を全て取得するユースケース
 */
export class GetAllUnmanagedBusinessUseCase {
  private repository: IUnmanagedBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - 未管理の取引の永続化の責務を負うクラス
   */
  constructor(repository: IUnmanagedBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 未管理の取引を全て取得する
   * @param pagingOptions - ページングオプション
   * @param fileType - 取引情報のファイルタイプ
   * @param filterContentItems - フィルターの一覧
   * @param isAsc - ソートの向き
   * @param sortTarget - ソートするカラム
   */
  public execute(
    pagingOptions: IPagingOptions,
    fileType: ImportFileType,
    filterContentItems: FilterContentItem[],
    isAsc: boolean,
    sortTarget?: string
  ): INetworkResult<[IUnmanagedBusiness[], IPagingOptions], Error> {
    try {
      return this.repository.allGet(pagingOptions, fileType, filterContentItems, isAsc, sortTarget);
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラーが発生しました'),
        },
      }; // 基本的にはここには到達しないはず
    }
  }
}
